import React, { useState } from "react";
import {
  Box,
  Button,
  useTheme,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import DevicesIcon from "@mui/icons-material/Devices";
import DeviceTypeManager from "./DeviceTypeManager";
import DefaultConfigTab from "../alert-components/DefaultConfigTab";

const DeviceTypeComponent = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState("All Types");

  const tabList = ["All Types", "Default Alert Configs"];

  const tabDescriptions = {
    "All Types": "View and manage all device types",
    "Default Alert Configs": "View and manage all default alert configs",
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Card */}
      <Card
        elevation={3}
        sx={{
          mb: 4,
          p: 2,
          background: "#F3F4F6",
          borderLeft: "4px solid #22C55E",
        }}
      >
        <CardContent>
          <Box display="flex" alignItems="center" mb={1}>
            <DevicesIcon fontSize="large" sx={{ mr: 2, color: "#22C55E" }} />
            <Typography variant="h4" fontWeight="bold">
              {activeTab}
            </Typography>
          </Box>
          <Typography color="text.secondary">
            {tabDescriptions[activeTab]}
          </Typography>
        </CardContent>
      </Card>

      <Box className="flex gap-2 mb-4">
        {tabList.map((tab) => (
          <Box
            key={tab}
            sx={{
              borderBottom: "2px solid",
              borderColor:
                activeTab === tab
                  ? theme.palette.mode === "dark"
                    ? theme.palette.primary.main
                    : "#22C55E"
                  : "transparent",
            }}
          >
            <Button
              onClick={() => setActiveTab(tab)}
              sx={{
                textTransform: "none",
                color:
                  activeTab === tab
                    ? theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : "#000000"
                    : theme.palette.text.primary,
              }}
            >
              {tab}
            </Button>
          </Box>
        ))}
      </Box>

      {activeTab === "All Types" && <DeviceTypeManager />}
      {activeTab === "Default Alert Configs" && <DefaultConfigTab />}
    </Box>
  );
};

export default DeviceTypeComponent;
